import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../../components/header";
import HeaderMembro from "../../components/header3";
import { BoxSkeleton, BirthdaySkeleton, WelcomeSkeleton, BirthdayTitleSkeleton } from "../../components/skeleton";
import "./style.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useAuth } from "../../context/AuthContext.jsx";
import api from "../../services/api.js";

// Items do menu inicial (Boxes com ícones) - ícones do bootstrap
const menuItems = [
  {
    id: 1,
    icon: "bi bi-graph-up-arrow",
    linkTo: "/fundChart",
    name: "Fundo",
    description: "Acompanhe a evolução do fundo da República",
  },
  {
    id: 2,
    icon: "bi bi-people-fill",
    linkTo: "/members",
    name: "Membros",
    description:
      "As informações mais atualizadas de cada ex-aluno e morador.",
  },
    {
    id: 3,
    icon: "bi bi-folder2-open",
    linkTo: "/documents",
    name: "Documentos",
    description: "Estatuto, Regimento interno e mais.",
  },
  /*
  {
    id: 3,
    icon: "bi bi-images",
    linkTo: "/",
    name: "Álbum de fotos",
    description: "Veja e reveja as fotos da nossa casa.",
  },
 */
];

// Função/Componente que cria as boxes
function createBox({ id, icon, linkTo, name, description, onNavigate }) {
  const handleCardClick = () => {
    onNavigate(linkTo);
  };

  return (
    <div
      key={id}
      className="col-md-3 d-flex align-items-stretch mb-5"
      data-aos="zoom-in"
      data-aos-delay="200"
      style={{ maxWidth: 300 }}
    >
      <div 
        className="icon-box clickable-card" 
        onClick={handleCardClick}
        style={{ cursor: 'pointer' }}
      >
        <div className="icon">
          <i className={icon}></i>
        </div>
        <h4 className="title">{name}</h4>
        <p className="description">{description}</p>
      </div>
    </div>
  );
}

const HomePage = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  const [allMembers, setAllMembers] = useState([]);
  const [birthdaysLoading, setBirthdaysLoading] = useState(true);

  useEffect(() => {
    if (!loading && !user) {
      navigate("/login");
    }
  }, [user, loading, navigate]);

  // Buscar dados da API
  useEffect(() => {
    setBirthdaysLoading(true);
    
    api
      .get("/api/birthday/")
      .then((res) => {
        // Filtra membros com aniversário válido
        const validMembers = res.data.filter(
          (member) => member.birthday !== null
        );
        setAllMembers(validMembers);
      })
      .catch((err) => {
        console.error("Erro ao buscar aniversários:", err);
        setAllMembers([]);
      })
      .finally(() => {
        setBirthdaysLoading(false);
      });
  }, []);

  if (loading) return <div>Carregando...</div>;
  if (!user) return null;

  const greeting = user.gender === "Male" ? "Bem-vindo" : "Bem-vinda";

  const upcomingBirthdays = allMembers
    .map((member) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      // Corrige o fuso ao criar a data
      const [year, month, day] = member.birthday.split("-").map(Number);
      const birthDate = new Date(year, month - 1, day);

      const nextBirthday = new Date(
        today.getFullYear(),
        birthDate.getMonth(),
        birthDate.getDate()
      );

      if (nextBirthday.getTime() < today.getTime()) {
        nextBirthday.setFullYear(today.getFullYear() + 1);
      }

      const diffTime = nextBirthday - today;
      const daysRemaining = Math.round(diffTime / (1000 * 60 * 60 * 24));

      return {
        ...member,
        birthDate, // agora birthDate é local
        nextBirthday,
        daysRemaining,
      };
    })
    .sort((a, b) => a.nextBirthday - b.nextBirthday)
    .slice(0, 5);

  // Função para renderizar skeletons dos boxes
  const renderBoxSkeletons = () => {
    return Array(3).fill(0).map((_, index) => (
      <BoxSkeleton key={index} />
    ));
  };

  // Função para renderizar skeletons dos aniversários
  const renderBirthdaySkeletons = () => {
    return Array(5).fill(0).map((_, index) => (
      <BirthdaySkeleton key={index} />
    ));
  };

  return (
    <div>
      <Header></Header>
      <HeaderMembro></HeaderMembro>

      {/* Seção principal da página */}

      <section className="home-section">
        <div
          className="container position-relative"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <div className="row flex-column flex-lg-row">
            {/* Coluna principal */}
            <div className="col-lg-10">
              <div className="row justify-content-center">
                {loading ? (
                  <WelcomeSkeleton />
                ) : (
                  <h1 className="row justify-content-center mt-5">
                    {greeting}, {user.nickname}!
                  </h1>
                )}
              </div>

              <div id="boxes" className="row icon-boxes justify-content-center">
                {loading ? renderBoxSkeletons() : menuItems.map((item) => createBox({...item, onNavigate: navigate}))}
              </div>
            </div>

            {/* Coluna lateral de aniversários */}
            <div className="col-12 col-lg-2 mt-5 d-flex flex-column align-items-lg-end align-items-center">
              {birthdaysLoading ? (
                <BirthdayTitleSkeleton />
              ) : (
                <h6 className="text-end mb-3">🎉 Próximos aniversários</h6>
              )}

              {birthdaysLoading ? (
                renderBirthdaySkeletons()
              ) : (
                upcomingBirthdays.map((person, index) => {
                  const isToday = person.daysRemaining === 0;

                  return (
                    <div
                      key={index}
                      className={`birthday-card rounded mb-3 ${
                        isToday ? "today-birthday" : ""
                      }`}
                      style={{
                        transition: "transform 0.2s, box-shadow 0.2s",
                        ...(isToday && { cursor: "pointer" }),
                      }}
                      onMouseEnter={(e) => {
                        if (isToday) {
                          e.currentTarget.style.transform = "scale(1.05)";
                          e.currentTarget.style.boxShadow =
                            "0 4px 8px rgba(0, 0, 0, 0.2)";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (isToday) {
                          e.currentTarget.style.transform = "scale(1)";
                          e.currentTarget.style.boxShadow = "none";
                        }
                      }}
                      onClick={() => {
                        if (isToday) {
                          window.open(
                            `https://wa.me/${person.telephone}`,
                            "_blank"
                          );
                        }
                      }}
                    >
                      <strong
                        style={{ display: "inline-flex", alignItems: "center" }}
                      >
                        {person.nickname}
                        {isToday && (
                          <i
                            className="bi bi-whatsapp"
                            style={{
                              marginLeft: "8px",
                              fontSize: "1.05em",
                              color: "black",
                            }}
                          ></i>
                        )}
                      </strong>
                      <br />
                      <small>
                        {person.birthDate.toLocaleDateString("pt-BR")}
                        {isToday
                          ? " ( Hoje! )"
                          : ` (${person.daysRemaining} dias)`}
                      </small>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
